import React from "react";
import loadJS from "fg-loadjs";
import { Loader } from "lib/components/vendor";

export const defaultLoader = <Loader active inline="centered" />;

window.__waitForScriptScriptsMap = window.__waitForScriptScriptsMap || new Map();
const scriptsMap = window.__waitForScriptScriptsMap;

const waitForScript =
  (url, { loader = defaultLoader } = {}) =>
  (Component) => {
    class WaitForScriptWrappedComponent extends React.PureComponent {
      state = {
        scriptLoaded: false,
      };

      componentDidMount() {
        let script = scriptsMap.get(url);
        if (!script) {
          script = {
            url,
            loaded: false,
            onLoad: [],
          };
          scriptsMap.set(url, script);

          loadJS(url, () => {
            script.loaded = true;
            script.onLoad.forEach((fn) => fn());
            script.onLoad = [];
          });
        }

        if (script.loaded) {
          this.setState({ scriptLoaded: true });
        } else {
          this._onScriptLoad = () => {
            this.setState({ scriptLoaded: true });
          };
          script.onLoad.push(this._onScriptLoad);
        }
      }

      componentWillUnmount() {
        if (!this.state.scriptLoaded) {
          const script = scriptsMap.get(url);
          if (!script) {
            return;
          }
          script.onLoad = script.onLoad.filter((fn) => fn !== this._onScriptLoad);
        }
      }

      render() {
        return this.state.scriptLoaded ? <Component {...this.props} /> : loader;
      }
    }

    return WaitForScriptWrappedComponent;
  };

export default waitForScript;



// WEBPACK FOOTER //
// ./src/lib/utils/waitForScript.js